import React from 'react';
import { usePage } from '@inertiajs/react';

export default function FlashMessage() {
    const { flash } = usePage().props;

    if (!flash) {
        return null;
    }

    const isError = flash.type === 'error';

    return (
        <div className="max-w-[1200px] mx-auto px-4">
            <div className={`mb-[30px] border-l-[3px] bg-white p-3 ${isError ? 'border-[#dc3939] text-[#dc3939]' : 'border-[#92C865] text-[#92C865]'}`}>
                <h5 className="text-[18px] font-bold" dangerouslySetInnerHTML={{ __html: (flash.description || '').replace(/\n/g, '<br>') }} />
                {flash.errors && flash.errors.length > 0 && (
                    <ul className="m-0 list-none p-0">
                        {flash.errors.map((error, index) => (
                            <li key={index}>{error}</li>
                        ))}
                    </ul>
                )}
            </div>
        </div>
    );
}
